import { styled } from "styled-components";

export const BusinessHoursHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const BusinessHoursLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.xlarge};
  color: ${({ theme }) => theme.colors.secondary};
  display: flex;
  align-items: center;
`;

export const StatusBadge = styled.span<{ $isOpen: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 18px;
  font-size: 14px;
  font-weight: 500;
  background: ${({ $isOpen, theme }) =>
    $isOpen ? "rgba(34, 197, 94, 0.1)" : "rgba(239, 68, 68, 0.1)"};
  color: ${({ $isOpen, theme }) =>
    $isOpen ? theme.colors.success : theme.colors.error};
  margin-left: 8px;
`;

export const EditButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 14px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  &:hover {
    background: ${({ theme }) => theme.colors.backgroundLightPrimary};
  }
`;

export const HoursList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const HoursItem = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.primary};
`;

export const DayName = styled.span<{ $isClosed: boolean }>`
  font-weight: 500;
  min-width: 100px;
  color: ${({ $isClosed, theme }) =>
    $isClosed ? theme.colors.error : theme.colors.secondary};
`;

export const TimeSlot = styled.span<{ $isClosed: boolean }>`
  color: ${({ $isClosed, theme }) =>
    $isClosed ? theme.colors.error : theme.colors.secondary};
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;
  max-height: 95vh;
  overflow-y: auto;
  padding: 30px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const ShopStatusContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ShopStatusLabel = styled.span`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.secondary};
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
  padding-top: 16px;
`;

export const ModalTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondary};
`;


export const BusinessHoursWrapper = styled.div`
  margin-bottom: 20px;
`;

export const BusinessHoursRow = styled.div`
  display: flex;
  justify-content: space-between;
  alignItems: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;
`;

export const BusinessHoursInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const BusinessHoursText = styled.span`
  font-weight: 500;
  color: #374151;
`;

export const Separator = styled.span`
  color: #9CA3AF;
`;

export const OpeningHoursSubheading = styled.div`
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 500;
  color: #6B7280;
`;

export const HoursListContainer = styled.div`
  margin-bottom: 20px;
`;

export const HoursRow = styled.div<{ $isClosed: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f3f4f6;
  color: ${props => props.$isClosed ? props.theme.colors.error : props.theme.colors.secondary};
  font-weight: ${props => props.$isClosed ? 'normal' : '500'};
`;

export const DayNameStyled = styled.span<{ $isClosed: boolean }>`
  font-weight: 500;
  color: ${props => props.$isClosed ? '#E25555' : '#76B041'};
  flex-basis: 120px; /* Give day name a consistent width */
  flex-shrink: 0;
`;

export const TimeDisplayStyled = styled.span<{ $isClosed: boolean }>`
  color: ${props => props.$isClosed ? '#E25555' : '#76B041'};
  font-size: 14px;
`;

export const ShopStatusSection = styled.div`
  background-color: #f9fafb;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  border: 1px solid #e5e7eb;
`;

export const ShopStatusRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ShopStatusInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ShopStatusTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
`;

export const ShopStatusDescription = styled.div`
  font-size: 14px;
  color: #6B7280;
`;

export const HoursEditorContainer = styled.div<{ $isShopOpen: boolean }>`
  opacity: ${props => props.$isShopOpen ? 1 : 0.5};
  pointer-events: ${props => props.$isShopOpen ? 'auto' : 'none'};
`;

export const EditorRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 0.5rem;
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.2s;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f9fafb;
  }
`;


export const SwitchWrapper = styled.div`
display: flex;
  align-items: center;
  gap: 8px;
`;

export const TimeInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem; /* Increased gap for better spacing */
`;

export const StatusLabel = styled.span<{ $isClosed: boolean }>`
  font-size: 14px;
  color: ${props => props.$isClosed ? '#9CA3AF' : '#374151'};
  min-width: 50px;
  font-weight: 500;
`;

export const TimeInput = styled.input`
  width: 130px;
  padding: 0.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  font-size: 0.9rem;
  background-color: #fff;
  color: #374151;

  &:disabled {
    background-color: #f9fafb;
    cursor: not-allowed;
  }
`;
